import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-dark flex flex-col items-center justify-center p-4 text-center">
            <div className="bg-gray-800 p-8 rounded-2xl shadow-2xl max-w-lg w-full">
                <div className="w-24 h-24 bg-red-900/30 rounded-full flex items-center justify-center mx-auto mb-6">
                    <svg className="w-12 h-12 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                </div>

                <h1 className="text-7xl font-bold text-gold mb-2">404</h1>
                <h2 className="text-2xl font-semibold text-white mb-4">Page Not Found</h2>

                <p className="text-gray-400 mb-8">
                    The page you are looking for doesn't exist or has been moved.
                    Please check the URL or navigate back to the portal.
                </p>

                <button
                    onClick={() => navigate('/')}
                    className="w-full bg-gold text-dark font-bold py-3 px-6 rounded-lg hover:bg-yellow-500 transition-colors"
                >
                    Return to Home
                </button>
            </div>

            <div className="mt-12 text-center text-gray-500 text-sm">
                <p>&copy; {new Date().getFullYear()} Dr. Vivara Healthcare. All rights reserved.</p>
            </div>
        </div>
    );
};

export default NotFound;
